<template>
  <div class="mxMobileContent">
    <div class="title">{{ $t('vpn.title') }}</div>
    <div v-if="isIOS" class="changeIphoneCode" @click="changeIphoneCode">
      <img class="changeIcon" src="../assets/downloadImg/vpnchange.png" alt="">
      <span v-if="isAliens">{{ $t('vpn.pcCoreZH') }}</span>
      <span v-else>{{ $t('vpn.pcCoreAliens') }}</span>
    </div>
    <div class="qrcode">
      <img class="qrcode_img" src="../assets/downloadImg/iphone-aliens.png" alt="" v-if="isIOS && isAliens">
      <img ref="zhQRcode" class="qrcode_img" src="../assets/downloadImg/iphone-zh.png" alt="" v-if="isIOS && !isAliens">
      <canvas v-if="!isIOS" ref="mxMobileqrCode"></canvas>
      <img class="qrcode_icon" src="../assets/downloadImg/vpnlogo.png" alt="">
    </div>
    <!-- <div class="downloadTips">{{ $t(isIOS ? 'vpn.tips' : 'mx.scanCodeDown') }}</div> -->
    <div class="configure" @click="downloadVPNGuidance(isIOS?'ios':'android')">{{ $t('vpn.configureSeq') }}</div>
    <div class="downloadBtn" @click="downloadVPN(false)">{{ $t('downloadNow') }}</div>
    <el-dialog
      :visible.sync="showIOSSuccess"
      :show-close="false"
      class="iosDialog"
      width="80%">
      <span>{{ $t('phoneSuccessTips') }}</span>
      <div slot="footer" class="dialog-footer" @click="showIOSSuccess = false">
        {{ $t('ok') }}
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcode';
import device from '@/mx-service/libs/utils/device'
import { is4aLogin } from '@/mx-service/libs/utils';
import { getApiConfig } from '@/mx-service/libs/http/config'

export default {
  data(){
    return{
      qrCodeData: getApiConfig().defaultMobileUrl,
      qrCodeOptions: {
        width: 176,
        height: 176
      },
      isIOS: true,
      vpnDownList: [],
      isAliens: false, // 是否为海外
      isDownLoadLinkLoading: false, // 立即下载按钮防抖
      isDownLoadConfigureLoading: false, // 配置下载按钮防抖
      showIOSSuccess: false
    }
  },
  methods: {
    onDecode(result) {
      console.log(result)
      // window.location.href = result;
    },
    // 下载vpn
    async downloadVPN(isDownloading, downloadParamId){
      if(device.isWechat()){
        this.$emit('showWX', true)
        return
      }
      let type = 'VPN_android_Link'
      if(isDownloading) {
        type = downloadParamId
      } else if(this.isIOS) {
        type = this.isAliens ? 'VPN_ios_Link_en' : 'VPN_ios_Link'
      }
      const status = await is4aLogin(type, true)
      console.log('状态如何status', status)
      if(!status) return
      console.log('看看列表数据this.vpnDownList---', this.vpnDownList)
      // if()
      const data = this.vpnDownList.filter(item => item.paramId === type)[0]
      console.log('this.vpnDownList', this.vpnDownList)
      console.log('type', type)
      console.log('data', data)
      window.location.href = data.paramValue;
      if(this.isIOS) {
        this.showIOSSuccess = true
      }
      // isLink ? this.isDownLoadLinkLoading = false : this.isDownLoadConfigureLoading = false
    },
    // 下载安装指引
    async downloadVPNGuidance(e){
      if(device.isWechat()){
        this.$emit('showWX', true)
        return
      }
      const lang = localStorage.getItem('locale')
      const params = lang.includes('zh') ? `VPN_${e}_Guidance`: `VPN_${e}_Guidance_en`
      // ios 没有下载链接 没有直接下载功能
      const status = await is4aLogin(params, true)
      console.log('状态如何status', status)
      if(!status) return
      console.log('看看列表数据this.vpnDownList---', this.vpnDownList)
      // 重新获取一次数据
      if(!this.vpnDownList || this.vpnDownList.length === 0) {
        console.log('重新获取数据')
        this.getData()
        // 生成二维码
        QRCode.toCanvas(this.$refs.mxMobileqrCode, this.qrCodeData, this.qrCodeOptions, function (error) {
          if (error) console.error(error);
        });
        console.log('第二次看看列表数据this.vpnDownList---', this.vpnDownList)
      }
      const data = this.vpnDownList.filter(item => item.paramId === params)[0]
      window.location.href = data.paramValue;
    },
    // 切换海内海外
    changeIphoneCode(){
      this.isAliens = !this.isAliens
    },
    // 监听是否有下载进程
    async isDownloading(){
      const downloadParamId = this.$route.query.id
      if(await is4aLogin() && downloadParamId && downloadParamId.toLowerCase().includes('vpn')){
        downloadParamId.toLowerCase().includes('link') ?
        this.downloadVPN(true, downloadParamId)
        :
        this.downloadVPNGuidance(downloadParamId.includes('ios') ? 'ios' : 'android')
      }
    },
    // 获取初始化数据
    async getData() {
      let getDataStatus = true
      try {
        const data = device.isMission() ? await mx.request("getMxVPNUrl") : await mx.request("getVPNUrl");
        console.log('vpn data', data)
        this.vpnDownList = data
        if(!this.isIOS) {
          this.qrCodeData = this.vpnDownList.filter(item => item.paramId === 'VPN_android_Link')[0].paramValue
        }
      } catch (error) {
        console.log('vpn data error', error)
        getDataStatus = false
      }
      return getDataStatus
    },
  },
  async mounted(){
    const isMobile = device.isMobile()

    // 获取当前系统语言(
    const language = navigator.language || navigator.userLanguage
    this.isAliens = !language.includes('zh')
    // 判断当前设备类型
    this.isIOS = device.isIOS()
    console.log('mounter isIOS---', device.isIOS())

    // 判断请求状态
    let getDataStatus = true
    // 判断单点登录状态
    const status = await is4aLogin()
    console.log('vpn 移动端 mounted-status', status)
    if((status && isMobile && window.location.pathname.indexOf("pcv5-4a.html") > -1) || device.isMission()) {
      console.log('开始请求')
      getDataStatus = await this.getData()
    }

    // 判断是否有下载进程
    if(getDataStatus) await this.isDownloading()

    // 生成二维码
    QRCode.toCanvas(this.$refs.mxMobileqrCode, this.qrCodeData, this.qrCodeOptions, function (error) {
      if (error) console.error(error);
    });

  }
}
</script>
<style lang="less" scoped>
.mxMobileContent {
  padding: 42px 0 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #191919;
    line-height: 45px;
  }
  .desc {
    margin-top: 4px;
    font-size: 18px;
    color: #666666;
    line-height: 25px;
  }
  .qrcode {
    margin-top: 28px;
    width: 176px;
    height: 176px;
    position: relative;
    z-index: 49;
    .qrcode_icon {
      position: absolute;
      z-index: 50;
      width: 40px;
      height: 40px;
      left: calc(50% - 20px);
      top: calc(50% - 20px);
    }
    .qrcode_img {
      width: 100%;
      height: 100%;
    }
  }
  .downloadTips {
    width: 80%;
    text-align: center;
    margin-top: 8px;
    font-size: 14px;
    color: #999999;
    line-height: 18px;
  }
  .downloadBtn {
    background: #2496FF;
    border-radius: 22px;
    width: 244px;
    height: 44px;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
  }
  .changeIphoneCode {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #2496FF;
    line-height: 26px;
    margin-top: 20px;
    .changeIcon {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
  }
  .configure {
    margin-top: 20px;
    font-size: 18px;
    color: #2496FF;
    line-height: 26px;
  }

}
</style>